import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { apiUrl } from './api_url';

// Endpoints that should never inherit the browser session JWT.
// These flows are driven by email/public tokens and must remain isolated
// from any logged-in user session in the same browser.
const PUBLIC_TOKEN_ENDPOINTS = new Set([
  'getPublicPreQualConfig',
  'getPreQualForm',
  'submitPreQual',
  'submitPublicPreQual',
  'getPublicPreQualVideoPresign',
  'validateCCAToken',
  'startCCAAssessment',
  'getCCACurrentQuestion',
  'submitCCAAnswer',
  'getVideoPresignUrl',
  'completeCCAAssessment',
  'getCandidateStorageUrl',
]);

export const rtkApi = createApi({
  reducerPath: 'rtkApi',
  baseQuery: fetchBaseQuery({
    baseUrl: apiUrl,
    prepareHeaders: (headers, { endpoint }) => {
      // Respect explicit auth headers defined by endpoint queries.
      if (headers.has('Authorization')) {
        return headers;
      }

      if (PUBLIC_TOKEN_ENDPOINTS.has(endpoint || '')) {
        return headers;
      }

      const token = localStorage.getItem('token');

      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }

      return headers;
    },
  }),
  tagTypes: [
    'JobOpening',
    'Applicant',
    'Assessment',
    'Interview',
    'PreQualConfig',
    'PreQualAnswer',
    'CCAQuestion',
    'CCAConfig',
    'CCACandidate',
    'CCAResult',
    'Dashboard',
    'DashboardUsers',
    'DashboardAssessments',
    'DashboardJobOpenings',
  ],
  endpoints: () => ({}),
});
